import { Modal, Link, Card, Text } from '@nike/eds'
import { useState } from 'react'
import { DetailsField } from '../../common/components/fields/DetailsField'
import { FilteredList } from '../../common/components/table/FilteredList'
import { date } from '../../common/utils/formatter'
import './TrackAndTraceGoodsHolders.scss'
import { GoodsHolderLink } from '../../common/components/links/Links'

export function TrackAndTraceGoodsHolders({ trackAndTraceEvent }) {
  const [visible, setVisible] = useState(false)
  return (
    <>
      <Link onClick={() => setVisible(!visible)}>{trackAndTraceEvent.count}</Link>
      <Modal
        className="track-and-trace-modal"
        isOpen={visible}
        onDismiss={() => setVisible(false)}
        headerSlot={
          <Text as="h3" font="title-3" className="eds-spacing--ml-16">
            Track & Trace Cartons
          </Text>
        }
      >
        {visible && (
          <>
            <Card className="track-and-trace-detail-fields">
              <DetailsField label="Time">
                {date(trackAndTraceEvent.event.eventTimestamp)}
              </DetailsField>
              <DetailsField label="Source">{trackAndTraceEvent.sourceSystemName}</DetailsField>
              <DetailsField label="Status">
                {trackAndTraceEvent.event.intermediateStatusCode}
              </DetailsField>
              <DetailsField label="Description">
                {!trackAndTraceEvent.event?.intermediateStatusCode &&
                !trackAndTraceEvent.event?.intermediateStatusDescription
                  ? trackAndTraceEvent.event?.carrierStatusDescription
                  : trackAndTraceEvent.event?.intermediateStatusDescription}
              </DetailsField>
            </Card>
            <FilteredList
              className="cartons-list"
              title="Carton Numbers"
              items={trackAndTraceEvent.goodsHolderNumbers}
              Cell={({ value }) => <GoodsHolderLink goodsHolderNumber={value} />}
            />
          </>
        )}
      </Modal>
    </>
  )
}
